<!--
 * @FileDescription: 售后订单列表-Mobile
 * @Author: 陈文景
 * @Date: 2022-11-08 15:23:21
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div>Mobile</div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>
